import { useIntl } from 'react-intl';
import { Row, Col, Form, Switch} from 'antd';

import { serializeFiles } from 'utils/common';

import {
  StyledForm,
  StyledFormItem,
  StyledButton,
  StyledInputNumber
} from 'styles/overrides';

import { LocaleSelector } from 'components/selectors';
import { MultipleUpload } from 'components/upload';

export default function MenuForm ({
  onSubmit,
  initialValues,
  isLoading = false,
  typeUpdate=false
}) {
  const intl = useIntl();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    let result = null
    if(typeUpdate === 'update') {
      const data = {
        file: serializeFiles(values.file),
        status: values?.status ? 1 : 0 
      };
      result = data
    }else {
      const data = {
        ...values,
        // status: +values.status,
        file: serializeFiles(values.file),
      };
      result = data
    }
    onSubmit?.(result);
  };

  return (
    <StyledForm
      layout="vertical"
      size="large"
      form={form}
      onFinish={handleSubmit}
      initialValues={initialValues || null}
    >
    <Row gutter={[32, 0]}>
      {!typeUpdate &&
          <>
            <Col span={24} sm={12}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'common.field.order',
                })}
                name="order"
                // rules={[{ required: true }]}
              >
                <StyledInputNumber min={1} />
              </StyledFormItem>
            </Col>
            <Col span={24} sm={12}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'common.field.locale',
                })}
                name="locale"
                rules={[{ required: true }]}
              >
                <LocaleSelector isFilter />
              </StyledFormItem>
            </Col>

            {/* <Col span={24} sm={12}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'common.field.published',
                })}
                name="status"
                valuePropName="checked"
              >
                <Switch />
              </StyledFormItem>
            </Col> */}

            <Col span={24}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'views.categories.form.label.file',
                })}
                name="file"
                rules={[{ required: true }]}
              >
                <MultipleUpload typeMenu='menu' />
              </StyledFormItem>
            </Col>
          </>
      }

      {typeUpdate &&
        <>
          <Col span={24} sm={12}>
            <StyledFormItem
              label={intl.formatMessage({
                id: 'common.field.published',
              })}
              name="status"
              valuePropName="checked"
            >
              <Switch />
            </StyledFormItem>
          </Col>

          <Col span={24}>
              <StyledFormItem
                label={intl.formatMessage({
                  id: 'views.categories.form.label.file',
                })}
                name="file"
                rules={[{ required: true }]}
              >
                <MultipleUpload typeMenu='menu' />
              </StyledFormItem>
            </Col>
        </>
      }

      <Col span={24}>
        <StyledFormItem style={{ textAlign: 'center' }}>
          <StyledButton htmlType="submit" type="primary" loading={isLoading}>
            {intl.formatMessage({ id: 'common.btn.save' })}
          </StyledButton>
        </StyledFormItem>
      </Col>
    </Row>
  </StyledForm>
  )
} 